[
  {
    "type": "function",
    "name": "buyPunk",
    "inputs": [
      { "name": "punkId", "type": "uint16", "internalType": "uint16" },
      { "name": "expectedListingWei", "type": "uint96", "internalType": "uint96" },
      { "name": "recipient", "type": "address", "internalType": "address" }
    ],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "placeBid",
    "inputs": [
      { "name": "bidWei", "type": "uint96", "internalType": "uint96" },
      { "name": "settlementWei", "type": "uint96", "internalType": "uint96" },
      {
        "name": "criteria",
        "type": "tuple",
        "internalType": "struct Punks.Filter",
        "components": [
          { "name": "requiredTraitMask", "type": "uint256", "internalType": "uint256" },
          { "name": "forbiddenTraitMask", "type": "uint256", "internalType": "uint256" },
          { "name": "anyOfTraitMask", "type": "uint256", "internalType": "uint256" },
          { "name": "requiredColorMask", "type": "uint256", "internalType": "uint256" },
          { "name": "forbiddenColorMask", "type": "uint256", "internalType": "uint256" },
          { "name": "anyOfColorMask", "type": "uint256", "internalType": "uint256" },
          { "name": "minPixelCount", "type": "uint16", "internalType": "uint16" },
          { "name": "maxPixelCount", "type": "uint16", "internalType": "uint16" },
          { "name": "minColorCount", "type": "uint8", "internalType": "uint8" },
          { "name": "maxColorCount", "type": "uint8", "internalType": "uint8" }
        ]
      },
      { "name": "includeIds", "type": "uint16[]", "internalType": "uint16[]" },
      { "name": "excludeIds", "type": "uint16[]", "internalType": "uint16[]" }
    ],
    "outputs": [{ "name": "bidId", "type": "uint256", "internalType": "uint256" }],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "cancelBid",
    "inputs": [{ "name": "bidId", "type": "uint256", "internalType": "uint256" }],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "adjustBidPrice",
    "inputs": [
      { "name": "bidId", "type": "uint256", "internalType": "uint256" },
      { "name": "weiToAdjust", "type": "uint96", "internalType": "uint96" },
      { "name": "increase", "type": "bool", "internalType": "bool" }
    ],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "acceptBid",
    "inputs": [
      { "name": "bidId", "type": "uint256", "internalType": "uint256" },
      { "name": "punkId", "type": "uint16", "internalType": "uint16" },
      { "name": "expectedListingWei", "type": "uint96", "internalType": "uint96" }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "withdraw",
    "inputs": [],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "balances",
    "inputs": [{ "name": "account", "type": "address", "internalType": "address" }],
    "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "lastBidId",
    "inputs": [],
    "outputs": [{ "name": "", "type": "uint256", "internalType": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "bids",
    "inputs": [{ "name": "bidId", "type": "uint256", "internalType": "uint256" }],
    "outputs": [
      { "name": "bidWei", "type": "uint96", "internalType": "uint96" },
      { "name": "settlementWei", "type": "uint96", "internalType": "uint96" },
      { "name": "bidder", "type": "address", "internalType": "address" }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "matchesPunk",
    "inputs": [
      { "name": "bidId", "type": "uint256", "internalType": "uint256" },
      { "name": "punkId", "type": "uint16", "internalType": "uint16" }
    ],
    "outputs": [{ "name": "", "type": "bool", "internalType": "bool" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "bidsMatchingPunk",
    "inputs": [
      { "name": "punkId", "type": "uint16", "internalType": "uint16" },
      { "name": "fromId", "type": "uint256", "internalType": "uint256" },
      { "name": "count", "type": "uint256", "internalType": "uint256" }
    ],
    "outputs": [
      { "name": "bidIds", "type": "uint256[]", "internalType": "uint256[]" },
      { "name": "nextId", "type": "uint256", "internalType": "uint256" }
    ],
    "stateMutability": "view"
  },
  {
    "type": "event",
    "name": "BidPlaced",
    "inputs": [
      { "name": "bidId", "type": "uint256", "indexed": true },
      { "name": "bidder", "type": "address", "indexed": true },
      { "name": "bidWei", "type": "uint96", "indexed": false },
      { "name": "settlementWei", "type": "uint96", "indexed": false }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "BidCancelled",
    "inputs": [{ "name": "bidId", "type": "uint256", "indexed": true }],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "BidAdjusted",
    "inputs": [
      { "name": "bidId", "type": "uint256", "indexed": true },
      { "name": "newBidWei", "type": "uint96", "indexed": false }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "BidAccepted",
    "inputs": [
      { "name": "bidId", "type": "uint256", "indexed": true },
      { "name": "punkId", "type": "uint256", "indexed": true },
      { "name": "seller", "type": "address", "indexed": true },
      { "name": "bidder", "type": "address", "indexed": false },
      { "name": "caller", "type": "address", "indexed": false },
      { "name": "listingWei", "type": "uint96", "indexed": false },
      { "name": "bidWei", "type": "uint96", "indexed": false },
      { "name": "settlementWei", "type": "uint96", "indexed": false }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "PunkPurchased",
    "inputs": [
      { "name": "punkId", "type": "uint256", "indexed": true },
      { "name": "seller", "type": "address", "indexed": true },
      { "name": "recipient", "type": "address", "indexed": true }
    ],
    "anonymous": false
  }
]
